import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, withStyles } from '@material-ui/styles';
import * as React from 'react';
import { compose, pure, withHandlers, withState } from 'recompose';
import { Text } from '../Text';
import Popover from './Popover';
const styles = (theme) => createStyles({
    containerHeader: {
        width: 60,
        marginBottom: 3,
        textAlign: 'center',
        cursor: 'pointer',
    },
    labelHeader: {
        height: 20,
        color: theme.color.font.light,
        marginTop: -1,
    },
    progressSpinner: {
        color: theme.color.grey.lightest,
    },
});
const UploadingPopover = (props) => {
    const { clickableComponent, children, testId = 'UploadingPopover' } = props;
    return (React.createElement(Popover, { "data-testid": `${testId}`, clickableComponent: clickableComponent, position: "bottomCenter", popoverArrow: true }, children));
};
const ComposedUploadingPopover = compose(withState('open', 'setOpen', false), withStyles(styles, { withTheme: true }), pure, withHandlers({
    clickableComponent: ({ classes, labelButton, isInProgress, theme, testId = 'UploadingPopover', }) => ({ setOpen, open }) => (React.createElement("div", { "data-testid": `${testId}-toggle`, className: classes.containerHeader, onClick: () => setOpen(!open) },
        React.createElement(CircularProgress, { className: classes.progressSpinner, variant: isInProgress ? 'indeterminate' : 'determinate', size: 22, value: 100 }),
        React.createElement(Text, { size: theme.font.size.small, className: classes.labelHeader }, labelButton))),
}))(UploadingPopover);
ComposedUploadingPopover.displayName = 'UploadingPopover';
export default ComposedUploadingPopover;
//# sourceMappingURL=UploadingPopover.js.map